import { render, staticRenderFns } from "./TestReport.vue?vue&type=template&id=18d870cf&scoped=true&"
import script from "./TestReport.vue?vue&type=script&lang=js&"
export * from "./TestReport.vue?vue&type=script&lang=js&"
import style0 from "./TestReport.vue?vue&type=style&index=0&id=18d870cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d870cf",
  null
  
)

export default component.exports